import * as Yup from "yup";
import { isCardNumberLengthValid, isExpiryValid, parseExpiry } from "../../../../../helpers/paymentCard";
import { i18n } from "../../../private/languageSelector";

// Validation for the Add Card / Update Card form
export const SubscriptionSchema = Yup.object().shape({
  name: Yup.string()
    .matches(/^[A-Za-z]+(?: [A-Za-z]+)+$/, i18n("SubscriptionModals.PleaseEnterAtLeastTwoNames"))
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
  // Digits only; the valid lengths depend on the card brand
  cardNumber: Yup.string()
    .test("cardNumber", i18n("SubscriptionModals.16NumberRequired"), (value) => !value || isCardNumberLengthValid(value))
    .required("Card number is required"),
  // "MM/YY", valid through the last day of the expiry month
  expiry: Yup.string()
    .test("format", i18n("SubscriptionModals.InvalidExpiryDate"), (value) => !value || (/^\d{2}\/\d{2}$/.test(value) && !!parseExpiry(value)))
    .test("expiry", "Expiry date must be in the future", (value) => !value || !parseExpiry(value) || isExpiryValid(value))
    .required("Expiry date is required"),
  ccv: Yup.string()
    .matches(/^\d{3,4}$/, i18n("SubscriptionModals.InvalidCCV"))
    .required("CCV is required"),
  country: Yup.string().required("Country is required"),
});
